import RTableLayout from "../../../layout/RTableLayout";
import { CFlex, CMargin, DText, Flex, Row } from "../../../../../styles/CommonStyles";
import { formatDate } from "../../../../../core/utils/common";
import Avatar from "../../../../common/utils/Avatar";
import { TradeTypeBadge } from "../../../../../styles/main/orders";
import { getTradeTypeColor } from "../../../../../core/utils/theme";
import { useMainContext } from "../../../../../core/contexts/main";
import { RespIndex } from "../../../../../styles/main/MainCommonStyles";

const RSwapListingTable = ({ data }) => {
    const { lang } = useMainContext()
    const { data: transactions } = data

    return (
        <RTableLayout data={data}>
            {transactions?.data?.map((item, idx) => {
                return (
                    <Row cs={"100%"} index={idx} key={item._id}>
                        {/* User section */}
                        <Flex justify={"space-between"}>
                            <CFlex fw>
                                <Avatar
                                    avatar={item.user?.avatar}
                                    name={item.user?.firstName?.[0] || "?"}
                                />
                                <CMargin margin={"6px"} />
                                <DText main>
                                    {item.user?.firstName} {item.user?.lastName}
                                </DText>
                            </CFlex>
                            <CFlex fw>
                                <DText fontSize={"s"}>{item.client?.userId}</DText>
                            </CFlex>
                        </Flex>

                        <CMargin margin={"8px"} />

                        {/* Amount & Wage */}
                        <Flex justify={"space-between"}>
                            <DText fontSize={"s"} main>
                                Amount:
                            </DText>
                            <DText main>{item.amount}</DText>
                        </Flex>
                        <Flex justify={"space-between"}>
                            <DText fontSize={"s"} main>
                                Wage:
                            </DText>
                            <DText main>{item.wage}</DText>
                        </Flex>

                        {/* Status */}
                        <Flex justify={"space-between"}>
                            <DText fontSize={"s"} main>
                                Status:
                            </DText>
                            <TradeTypeBadge color={getTradeTypeColor(item.status)}>
                                {item.status}
                            </TradeTypeBadge>
                        </Flex>

                        {/* Date + Time */}
                        <Flex justify={"space-between"}>
                            <DText fontSize={"s"} main>
                                Date:
                            </DText>
                            <DText fontSize={"s"} main>
                                {formatDate(item.createdAt, "date", lang)}
                            </DText>
                        </Flex>
                        <Flex justify={"space-between"}>
                            <DText fontSize={"s"} main>
                                Time:
                            </DText>
                            <DText fontSize={"s"} main>
                                {formatDate(item.createdAt, "time", lang)}
                            </DText>
                        </Flex>

                        {/* Index */}
                        <RespIndex>{idx + 1}</RespIndex>
                    </Row>
                )
            })}
        </RTableLayout>
    )
}

export default RSwapListingTable
